export enum EmptyConfig {
    Null = 1 << 0,
    Undefined = 1 << 1,
    EmptyString = 1 << 2,
    All = ~(~0 << 3),
}
